// THE AUSTIN JOKE ENGINE.
//
// Every piece of feedback in this app is a pun on the name Austin. The one
// rule that makes it land rather than grate: NOTHING REPEATS TWICE IN A ROW.
// A pun bank with a plain random pick will say "AUSTINISHING!" twice running
// about one time in eight, and the second one is the moment the joke dies.
//
// So `pun()` remembers the last line it returned FOR THAT KIND and re-rolls.
// Per kind, not globally — a correct answer and a streak line are different
// jokes and should not block each other.

const BANKS = {
  // --- the good outcomes ----------------------------------------------------
  correct: [
    'AUSTINISHING!',
    'Aus-some!',
    'Austin-tatious!',
    'Well Austin-ded.',
    'Austin-ishingly good.',
    'That is Austin-dard.',
    'Ex-Austin-plary.',
    'Austin the money.',
    'Not bad, Austin.',
    'Austin-taneous.',
  ],

  // Shown from three in a row upward.
  streak: [
    'AUSTIN ON FIRE',
    'Un-Austin-able.',
    'Austin-oppable.',
    'FULLY AUSTINATED',
    'Austin on a roll.',
    'Nobody can Austin you.',
    'Austin-omous mode.',
  ],

  // --- the bad outcomes -----------------------------------------------------
  // Never scolding. The brief is explicit: losing should feel like running out
  // of puff, not like being told off.
  wrong: [
    'Not your finest hour, mate.',
    'Austin, we have a problem.',
    'Ex-Austin-guished.',
    'That one got away.',
    'Austin-adequate.',
    'Ooft. Not that one.',
    'Close, but no Austin.',
    'Austin down a peg.',
  ],

  // --- pressure -------------------------------------------------------------
  clock: [
    "You're EXHAUSTIN the clock!",
    'Time is Austin away!',
    'Clock is Austin out!',
    'Running out of Austin!',
  ],

  loading: [
    'Just-in time...',
    'Catching our breath...',
    'Austin the questions...',
    'Warming up...',
    'Just-in a second...',
  ],

  // --- the very end ---------------------------------------------------------
  gameOver: [
    'Have a breather.',
    'That is you done.',
    'Puff. Puff. Puff.',
    'Out of Austin.',
    'Legs gone.',
  ],

  // Shown when he beats his own record.
  record: [
    'NEW RECORD. Austin-ishing.',
    'You just out-Austin-ed yourself.',
    'Personal best. Austin-tatious.',
    'Record broken. Aus-some.',
  ],

  // The empty trophy cabinet, the no-runs-yet state.
  nudge: [
    'Nothing here yet. Go and get Austin.',
    'Empty. For now.',
    'This is where the bragging goes.',
  ],
};

/** The three difficulty rungs, in the app's own words. */
export const DIFFICULTY_LABEL = {
  'warm-up': 'Warm-up',
  sweaty: 'Sweaty',
  'fully-austinated': 'FULLY AUSTINATED',
};

const lastSeen = new Map();

/**
 * One line from a bank, never the same one twice in a row.
 *
 * The guard counter matters: with a one-line bank the do/while would spin
 * forever, and a bank can legitimately shrink to one line while being edited.
 */
export function pun(kind) {
  const bank = BANKS[kind];
  if (!bank || !bank.length) return '';
  if (bank.length === 1) return bank[0];

  let pick;
  let guard = 0;
  do {
    pick = bank[Math.floor(Math.random() * bank.length)];
    guard += 1;
  } while (pick === lastSeen.get(kind) && guard < 12);

  lastSeen.set(kind, pick);
  return pick;
}

/** Every line in a bank, for the settings screen's "see them all" list. */
export const punBank = (kind) => [...(BANKS[kind] ?? [])];

/** How many puns the app knows. Used on the About screen, purely to show off. */
export const punCount = Object.values(BANKS).reduce((n, b) => n + b.length, 0);
